<div class="header">
  <div>
      <div class="subtitle">{{ document.type | human | titlecase }}
      <span
        class="link"
        go-to-details
        [element]="document"
        [mode]="'modal'"
      >
        #{{document.correlative_id}}
      </span>
      </div>
  </div>
</div>

<ng-container *ngComponentOutlet="component(); inputs: { document: workInstance().document }"></ng-container>
